import React from 'react';

import './styles.scss';

const textCtor = ({WrapperComponent = 'div', className: defaultClassName}) => ({children, className, ...props}) => (
  <WrapperComponent className={[defaultClassName, className].join(' ')}>
    {children}
  </WrapperComponent>
);

export const PageTitleText = textCtor({
  WrapperComponent: 'h1',
  className: 'page-title'
});

export const PageHeaderId = textCtor({
  WrapperComponent: 'span',
  className: 'page-title page-title--id'
});

export const ModalTitleText = textCtor({
  WrapperComponent: 'h2',
  className: 'page-title'
});

export const PrimaryDataText = textCtor({
  WrapperComponent: 'span',
  className: 'data-text data-text--primary'
});
export const PrimaryDataTextMedium = textCtor({
  WrapperComponent: 'span',
  className: 'data-text data-text--primary data-text--fz-medium'
});
export const SecondaryDataText = textCtor({
  WrapperComponent: 'span',
  className: 'data-text data-text--secondary'
});
